module.exports = __webpack_public_path__ + "img/warning.9300f981.svg";